function Attribution() {
   return (
      <footer className="attribution">
         <p>developed by <a href="https://bit.ly/PryUchiha" target="_blank" rel="noreferrer">PryUchiha</a></p>
      </footer>
   );
}

export default Attribution;
